import { render, staticRenderFns } from "./BtnExcluirParcelamento.vue?vue&type=template&id=61513b90&"
import script from "./BtnExcluirParcelamento.vue?vue&type=script&lang=js&"
export * from "./BtnExcluirParcelamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports